<template>
  <div class="list-group drag p10">
    <draggable class="dragArea" :options="{group:'ITEMS'}" v-model="items">
      <v-card class="list-group-item pa-3 " v-for="item in items" :key="item.id">
        <label>
          {{item.title}}
        </label>
      </v-card>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { EventBus } from '@/services/event-bus'

  export default {
    components: {
      draggable
    },
    data() {
      return {
        content: []
      }
    },
    props: { items: { type: Array } },
    created() {
      EventBus.$on('save-template',this.shareContent)
    },
    beforeDestory() {
      EventBus.$off('save-template',this.shareContent)
    },
    mounted() {
      this.content = this.items 
    },
    methods: {
      shareContent() {
        this.$emit('content-array', this.items)
      }
    },
    watch: {
      items() {
        this.content = this.items
      }
    }
  }
</script>

<style scoped>

.list-group-item{
  border-bottom: 1px solid black;
  /* background-color: #242c50; */
  cursor: grab;
}

.list-group-item:hover {
  transform: scale(1.04); 
}
</style>